<template>
    <div>
        <template v-if="crud_company === true && cities != null && pocs != null">
            <div class="page-top mb-1 mb-3">
                <h1> Add Company </h1>
            </div>
            <div class="global-main">
                <form id="companyForm" @submit.prevent="addCompanyData">
                    <div class="tab-content-inner">
                         <div class="form-group">
                            <label>Associate Company</label>
                            <select v-model="form.parent_company" data-live-search="true" name="parent_company" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('parent_company') }">
                                  <option value="" selected>Select Parent Company</option>
                                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                        {{ company.name }}
                                    </option>
                            </select>
                            <has-error :form="form" field="parent_company"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Payment Engine <em class="required">*</em></label>
                            <select v-model="form.payment_engine" name="payment_engine" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('payment_engine') }">
                                <option value="" selected>Select Payment Engine</option>
                                <option value="MEEZAN">Meezan Bank</option>
                                <option value="FINCA">Finca Microfinance Bank</option>
                                <option value="EASY_PAISA">Easy Paisa</option>
                                <option value="NBP_FUND">NBP Funds</option>
                                <option value="FAYSAL">Faysal Bank</option>
                            </select>
                            <has-error :form="form" field="payment_engine"></has-error>
                        </div>
                        <div class="form-group" v-show="form.payment_engine == 'EASY_PAISA'">
                            <label> Corporate Pin <em class="required">*</em></label>
                            <input v-model="form.corporate_pin" type="text" name="corporate_pin" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('corporate_pin') }">
                            <has-error :form="form" field="corporate_pin"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Name <em class="required">*</em></label>
                            <input v-model="form.name" type="text" name="name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Email <em class="required">*</em></label>
                            <input v-model="form.email" type="email" name="email" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Phone <em class="required">*</em></label>
                            <input v-model="form.phone" @keypress="isNumber($event)" type="text" name="phone" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('phone') }" maxlength="12">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                            <label> WalletID <em class="required">*</em></label>
                            <input v-model="form.walletID" @keypress="isNumber($event)" type="text" name="walletID" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('walletID') }">
                            <has-error :form="form" field="walletID"></has-error>
                        </div>
                        <div class="form-group">
                            <label> NTN </label>
                            <input v-model="form.ntn" @keypress="isNumber($event)" type="text" name="ntn" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('ntn') }">
                            <has-error :form="form" field="ntn"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fax </label>
                            <input v-model="form.fax" type="text" name="fax" class="form-control" autocomplete="off" value="" :class="{ 'is-invalid': form.errors.has('fax') }">
                            <has-error :form="form" field="fax"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Address 1 <em class="required">*</em></label>
                            <textarea v-model="form.address_1" name="address_1" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('address_1') }"></textarea>
                            <has-error :form="form" field="address_1"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Address 2 </label>
                            <textarea v-model="form.address_2" name="address_2" class="form-control" autocomplete="off" value="" :class="{ 'is-invalid': form.errors.has('address_2') }"></textarea>
                            <has-error :form="form" field="address_2"></has-error>
                        </div>
                        <div class="form-group">
                            <label> City <em class="required">*</em></label>
                            <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2 form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                <option value="" selected>Select City</option>
                                <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                    {{ city.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="city_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Postal Code<em class="required">*</em> </label>
                            <input v-model="form.postal_code" type="text" name="postal_code" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('postal_code') }">
                            <has-error :form="form" field="postal_code"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Website </label>
                            <input v-model="form.website" type="text" name="website" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('website') }">
                            <has-error :form="form" field="website"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Company Type</label>
                            <select v-model="form.companyType" name="companyType" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('companyType') }">
                                <!-- <option value="" selected>Select Company Type</option> -->
                                <option value="PAYROLL">Default</option>
                                <option value="MERCHANT">Merchant</option>
                            </select>
                            <has-error :form="form" field="companyType"></has-error>
                        </div>
                        <h3>POC Details<em class="required">*</em></h3>
                        <br>
                        <div class="form-group">
                            <label> POC <em class="required">*</em></label>
                            <select v-model="form.poc_id" name="poc_id" data-live-search="true" class="selectpicker custom-select2 form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('poc_id') }" v-if="pocs != null">
                                <option value="" selected>Select POC</option>
                                <option v-for="poc in pocs" v-bind:value="poc.id" v-bind:key="poc.id">
                                    {{ poc.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="poc_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Company Size <em class="required">*</em></label>
                            <input v-model="form.company_size" type="text" name="company_size" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('company_size') }">
                            <has-error :form="form" field="company_size"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Monthly Throughput <em class="required">*</em></label>
                            <input v-model="form.monthly_throughput" type="text" name="monthly_throughput" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('monthly_throughput') }">
                            <has-error :form="form" field="monthly_throughput"></has-error>
                        </div>
                        <div class="form-group">
                            <label> On Board Source <em class="required">*</em></label>
                            <select v-model="form.on_board" name="on_board" class="selectpicker custom-select2 form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('on_board') }">
                                <option value="" selected>Select Source</option>
                                <option value="FINJA">Finja Pvt LTD</option>
                                <option value="FINCA">Finca Microfinance Bank</option>
                                <option value="MEEZAN">Meezan Bank</option>
                                <option value="NBP_FUND">NBP Funds</option>
                                <option value="EASY_PAISA">Easy Paisa</option>
                                <option value="FAYSAL">Faysal Bank</option>
                            </select>
                            <has-error :form="form" field="on_board"></has-error>
                        </div>

                        <div class="form-group">
                            <label> On Board Date </label>
                            <datepicker name="on_board_date" v-model="form.on_board_date" input-class="form-control" autocomplete="off"></datepicker>
                        </div>
                        <!-- <h3> Store Option </h3>
                        <br>
                        <div class="form-group">
                            <label> Store Permission </label>
                            <select v-model="form.finjaStore" name="finjaStore" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('finjaStore') }">
                                <option value="ENABLED">ENABLED</option>
                                <option value="DISABLED">DISABLED</option>
                            </select>
                            <has-error :form="form" field="finjaStore"></has-error>
                        </div> -->
                        <h3> Invoice Discounting Option </h3>
                        <br>
                        <div class="form-group">
                            <label> Invoice Discounting </label>
                            <select v-model="form.invoice_discounting" name="invoice_discounting" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('invoice_discounting') }">
                                <option value="SET_NOW" selected>SET NOW</option>
                                <option value="ENABLED">ENABLED</option>
                                <option value="DISABLED">DISABLED</option>
                            </select>
                            <has-error :form="form" field="invoice_discounting"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/companies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    payment_engine : '',
                    companyType : '',
                    corporate_pin : '',
                    name : '',
                    email : '',
                    phone : '',
                    walledID : '',
                    ntn : '',
                    fax : '',
                    address_1 : '',
                    address_2 : '',
                    city_id : '',
                    postal_code : '',
                    website : '',
                    poc_id : '',
                    company_size : '',
                    monthly_throughput : '',
                    on_board : '',
                    on_board_date : new Date(),
                    finjaStore : 'DISABLED',
                    invoice_discounting : 'SET_NOW',
                }),
                cities: null,
                companies:[],
                pocs: null,
                crud_company: null,
            }
        },
        methods: {
            addCompanyData() {
                this.$Progress.start();
                this.form.post('api/addCompany')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Company created successfully');
                        this.$router.push('/companies');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            getAddCompanyData(){
                this.$Progress.start();
                axios.get('/api/addCompanyData')
                .then(res => {
                    if(res.status == 200){
                        this.cities = res.data.cities;
                        this.pocs = res.data.pocs;
                        this.companies=res.data.companies;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_company').then(result => {
                this.crud_company = result.crud_company;
            }).then(result => {
                if(this.crud_company == true){
					this.getAddCompanyData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
